import { render, staticRenderFns } from "./blue.vue?vue&type=template&id=455580f7"
import script from "./blue.vue?vue&type=script&lang=js"
export * from "./blue.vue?vue&type=script&lang=js"
import style0 from "./blue.vue?vue&type=style&index=0&id=455580f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports